<template>
  <div class="main-router">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index) in list" :key="index" v-if="item.path" :to="{ path: item.path }">{{item.name}}</el-breadcrumb-item>
      <el-breadcrumb-item v-else :to="false">{{item.name}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script  >
export default {
  name: 'HeaderImg',
  props: {
    list: { type: Array, default: [] },
  },
}
</script>

<style lang="scss" scoped>
.main-router{
    padding: 20px 0;
    max-width: 1200px;
    margin: 0  auto;
    background: transparent;
}
</style>
